// Copyright (c) StrangeBee 2023

import React, { ReactElement, useContext } from 'react';
import { StatusContext } from '@Context/StatusProvider';
import CircleLogo from '@Atoms/CircleLogo/CircleLogo';
import { Badge } from 'antd';

import './MainLayoutSiderFooter.scss';
import AboutSection from '../AboutSection/AboutSection';

interface MainLayoutSiderFooterProps {
    isMenuClosed: boolean;
}

const MainLayoutSiderFooter = React.memo(({ isMenuClosed }: MainLayoutSiderFooterProps): ReactElement => {
    const {
        version,
        mispServers,
        cortexServers = [],
        hasCortexConnector,
        hasMispConnector,
    } = useContext(StatusContext);

    const cortexHasAlerts = cortexServers.some(({ alerts = [] }) => alerts.length > 0);

    return (
        <div className="sider-footer">
            <div className="sider-footer__logos">
                {hasCortexConnector && (
                    <AboutSection
                        triggerElem={
                            <Badge dot={cortexHasAlerts} className="sider-footer__logos__badge">
                                <CircleLogo
                                    className="sider-footer__logos__button"
                                    imageName="cortex-logo"
                                    status={
                                        cortexServers.length
                                            ? cortexServers.every(({ status }) => status === 'ERROR')
                                                ? 'error'
                                                : cortexServers.every(({ status }) => status === 'OK')
                                                ? 'success'
                                                : 'warning'
                                            : 'disabled'
                                    }
                                />
                            </Badge>
                        }
                    />
                )}

                {hasMispConnector && (
                    <AboutSection
                        triggerElem={
                            <CircleLogo
                                className="sider-footer__logos__button"
                                imageName="misp-logo"
                                status={
                                    mispServers.length
                                        ? mispServers.every(({ status }) => status === 'ERROR')
                                            ? 'error'
                                            : mispServers.every(({ status }) => status === 'OK')
                                            ? 'success'
                                            : 'warning'
                                        : 'disabled'
                                }
                            />
                        }
                    />
                )}
                <span className="sider-footer__version">
                    {!isMenuClosed && <span className="sider-footer__version-label">Version: </span>}
                    {version}
                </span>
            </div>
        </div>
    );
});

export default MainLayoutSiderFooter;
